import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Grid
} from '@material-ui/core';

import { fetchItem, selectFetchStatus, selectAccess } from './itemSlice';

import TopSection from '../common/topSection';
import BreadCrumb from '../common/breadcrumb';
import Alert from '../common/alert';
import Loading from '../common/loading';
import PinButton from '../pins/PinButton';

import ItemPagePC1 from './itemPagePC1';
import ItemPagePC24 from './itemPagePC24';
import TreadItemPagePC24 from '../tread/treadItemPagePC24';
import useTitle from '../../hooks/use-title.hook';

const ItemPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { itemOwnerId, itemId } = useParams();
  const { fetchStatus, fetchError, item } = useSelector(selectFetchStatus);
  const canEdit = useSelector(selectAccess);

  const breadcrumbItems = [
    {name: itemOwnerId, link: `/pih/owner/${itemOwnerId}`},
    {name: t('nav:itemFamilies'), link: `/pih/owner/${itemOwnerId}/families`},
    item.itemFamilyCode ? {name: item.itemFamilyName, link: `/pih/owner/${itemOwnerId}/families/${item.itemFamilyCode}`} : null,
    {name: itemId}
  ].filter(Boolean);

  const ownerSpecificComponents = {
    PC1: ItemPagePC1,
    PC24: item?.itemLineCode === 'IL-PC24R-010' ? TreadItemPagePC24 : ItemPagePC24,
  };

  const ItemPageComponent = ownerSpecificComponents[itemOwnerId];

  useEffect(() => {
    // Fetch data from server
    dispatch(fetchItem({ownerId: itemOwnerId, itemId: itemId}));
  }, [dispatch, itemOwnerId, itemId]);

  useTitle(itemId);

  return (
    <>
      <TopSection>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <BreadCrumb items={breadcrumbItems} />
          </Grid>
          <Grid item>
            {item.itemCode ? <PinButton itemCode={item.itemCode} itemName={item.itemFamilyName} itemOwner={itemOwnerId} itemType="item" /> : null }
          </Grid>
        </Grid>
      </TopSection>

      <Box p={3.5} pb="70px">
        {fetchStatus === 'loading' ? <Loading /> : null}
        {fetchStatus === 'failed' ? <Alert severity="error">{t(`errors:${fetchError}`)}</Alert> : null}
        {fetchStatus === 'succeeded' ? (ItemPageComponent ? <ItemPageComponent key={itemOwnerId} canEdit={canEdit} /> : <Alert severity="error">View not implemented for owner {itemOwnerId}</Alert>) : null}
      </Box>
    </>
  );
};

export default ItemPage;
